<div>
  <up-text-field
    [ngClass]="{ longWidth: fullWidth }"
    [fieldLabel]="fieldLabel"
    [errorState]="errorState"
    [fieldMessage]="errorMessageText"
  >
    <input
      id="phone"
      type="text"
      [formControl]="phoneControl"
      [placeholder]="placeholder"
      (blur)="onBlur()"
      (keydown)="preventNonNumeric($event)"
      (input)="formatPhoneNumber()"
      maxlength="15"
      autocomplete="off"
    />
  </up-text-field>
</div>
